import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@core/store';

import {
  AddDownloadPayload,
  DownloadItem,
  DownloadsState,
  UpdateDownloadStatusPayload
} from '../../types/downloads';

const initialState: DownloadsState = {
  items: []
};

export const downloadsSlice = createSlice({
  name: 'downloads',
  initialState,
  reducers: {
    addDownload: (state, action: PayloadAction<AddDownloadPayload>) => {
      const newDownload: DownloadItem = {
        ...action.payload,
        status: 'started',
        timestamp: Date.now()
      };
      state.items.push(newDownload);
    },
    updateDownloadStatus: (
      state,
      action: PayloadAction<UpdateDownloadStatusPayload>
    ) => {
      const download = state.items.find(
        (item) => item.id === action.payload.id
      );
      if (download) {
        download.status = action.payload.status;
        if (action.payload.error) {
          download.error = action.payload.error;
        }
      }
    },
    removeDownload: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    removeAllDownloads: (state) => {
      state.items = [];
    }
  }
});

export const {
  addDownload,
  updateDownloadStatus,
  removeDownload,
  removeAllDownloads
} = downloadsSlice.actions;
export default downloadsSlice.reducer;
export const selectDownloads = (state: RootState) => state.downloads.items;
